
import { BranchDesignator, CodeNext, Export } from "@fusion-advantage/backcompat"
import { age, dateAndDow } from "../util"
import { DateTime } from 'luxon'

export const exportMemberName = (exp?: Export|null): string => {
	return exp?.Form.Member.MemberName ?? 'Unknown Member'
}

export const exportMemberBioGenderStr = (exp?: Export|null): string => {
	switch(exp?.Form.Member.Gender) {
		case 1:
			return 'M'
		case 2:
			return 'F'
		default:
			return 'X'
	}
}

export const exportMemberAge = (exp?: Export|null): number|null => {
	if(!exp?.Form.Member.BirthDate) {
		return null
	}
	return age(DateTime.fromISO(exp.Form.Member.BirthDate))
}

export const exportClientName = (exp?: Export|null): string|null => {
	if(!exp) {
		return null
	}
	const member = exp.Form.Member
	if(!member.ClientName) {
		return null
	}
	let name = member.ClientName
	if(member.ClientLOB) {
		name += ' (' + member.ClientLOB + ')'
	}
	return name
}

export const exportMemberInfoString = (exp?: Export|null): string => {
	if(!exp) {
		return ''
	}
	const member = exp.Form.Member
	let info = `[${exportMemberBioGenderStr(exp)}] ${exportMemberAge(exp)} yrs, DOB ${member.BirthDate ?? 'Unknown'}`
	const clientName = exportClientName(exp)
	if(clientName) {
		info += ', ' + clientName
	}
	return info
}

export const exportDateOfService = (exp?: Export): string|null => {
	if(!exp?.Form.Encounter.DateOfService) {
		return null
	}
	return dateAndDow(DateTime.fromISO(exp.Form.Encounter.DateOfService))
}

export const exportDateOfServiceInfoString = (exp?: Export|null): string => {
	const evalDate = (exp ? exportDateOfService(exp) : null) ?? 'Unknown Date'
	return 'Eval ' + evalDate
}

// Used for test data for sandbox calculations
export const testExport: Export = {
	Form: {
		Encounter: {
			Encounter_GUID: '6E8637D3-7976-4BD8-B708-FFD13470E242',
			EncounterCreateDT: '',
			EncounterLastUpdateDT: '',
			EncounterAppLastStatusDT: '',
			BranchGUID: '7F1058CE-D228-4313-9F4F-74C7F17DB105',
			CodeNext: CodeNext.NotStarted,
			Salesforce_ID: '0015f00000AbCd1AAF',
			BranchDesignatorV2: BranchDesignator.InHome,
		},
		Member: {
			BirthDate: '2000/01/01',
			CMSID: 'Test CMSID',
			Gender: 1,
			MemberID: 'Test ID',
			MemberName: 'Test Name',
			Member_GUID: 'F694CA7E-7330-4DEE-931E-EE2A410791AE'
		},
		CancelReason: [],
		ConceptStatuses: {}
	}
}
